export default class WindowUtils {
    static scrollToV(targetElement, offset = 0) {
        window.scrollTo(0, targetElement.getBoundingClientRect().top + window.scrollY + offset);
    }
}
//# sourceMappingURL=WindowUtils.js.map